/**
 * Веб-замена expo-secure-store.
 *
 * localStorage может быть недоступен: приватный режим Safari, отключённые
 * сторонние данные, iframe с жёсткой политикой. Поэтому все обращения
 * защищены, а при отказе используется память текущей вкладки.
 */

const memory = new Map<string, string>()

function safeLocalStorage(): Storage | null {
  try {
    const probe = '__lc_probe__'
    window.localStorage.setItem(probe, '1')
    window.localStorage.removeItem(probe)
    return window.localStorage
  } catch {
    return null
  }
}

const store = typeof window === 'undefined' ? null : safeLocalStorage()

export const storage = {
  get(key: string): string | null {
    if (store) {
      try {
        return store.getItem(key)
      } catch {
        /* падаем в память */
      }
    }
    return memory.get(key) ?? null
  },

  set(key: string, value: string): void {
    memory.set(key, value)
    if (store) {
      try {
        store.setItem(key, value)
      } catch {
        /* квота или приватный режим — остаёмся в памяти */
      }
    }
  },

  remove(key: string): void {
    memory.delete(key)
    if (store) {
      try {
        store.removeItem(key)
      } catch {
        /* игнорируем */
      }
    }
  },

  getJSON<T>(key: string, fallback: T): T {
    const raw = this.get(key)
    if (!raw) return fallback
    try {
      return JSON.parse(raw) as T
    } catch {
      return fallback
    }
  },

  setJSON(key: string, value: unknown): void {
    try {
      this.set(key, JSON.stringify(value))
    } catch {
      /* несериализуемое значение — молча пропускаем */
    }
  },
}
